<template>
  <div class="global-search-wrapper">
    <a-auto-complete placeholder="搜索" class="global-search" style="width: 100%" optionLabelProp="text"
      @select="onSelect" @search="onSearch">
      <template slot="dataSource">
        <a-select-option v-for="item in this.dataSearch" :key="item.name" :text="item.displayName">
          {{ item.displayName }}
        </a-select-option>
      </template>
      <a-input>
        <a-button slot="suffix" class="search-btn" type="primary">
          <a-icon type="search" />
        </a-button>
      </a-input>
    </a-auto-complete>
  </div>
</template>

<script>
import account from "@/mixins/account";
export default {
  name: "hp-manager-headersearch",
  data() {
    return {
      keyWord: ""
    };
  },
  computed: {
    dataSource: function () {
      let menus = JSON.parse(sessionStorage.getItem("menus") || "[]");
      let ds = [];
      if (menus) {
        menus.forEach(m => {
          if (m.submenus) {
            m.submenus.forEach(n => {
              ds.push({
                name: n.name,
                displayName: n.displayName,
                linkUrl: n.linkUrl
              });
            });
          }
        });
        ds = ds.filter(a => a.name != "homepage");
      }
      return ds;
    },
    dataSearch: function () {
      if (this.keyWord && this.keyWord.length > 0) {
        let ds = [];
        this.dataSource.forEach(a => {
          if (a.displayName.indexOf(this.keyWord.trim()) != -1) {
            ds.push(a);
          }
        });
        return ds;
      }
      return this.dataSource;
    }
  },
  methods: {
    onSearch(value) {
      this.keyWord = value;
    },
    onSelect(value) {
      let item = this.dataSource.filter(a => a.name == value)[0];
      if (item && item.linkUrl) {
        this.keyWord = item.displayName;
        this.$router.push({
          path: item.linkUrl
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/output.scss";

.global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input-suffix {
  right: 0;
}

.global-search-wrapper {
  flex: 1;
  margin: 0 100px;
  position: relative;
  display: flex;
  align-items: center;
}

.global-search {
  width: 100%;
}

.global-search.ant-select-auto-complete .ant-select-selection--single {
  margin-right: -46px;
}

.global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 62px;
}

.global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input-suffix {
  right: 0px;
}

.ant-input-affix-wrapper .ant-input-suffix {
  right: 0 !important;
}

.global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input-suffix button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/headersearch.vue